var JoyUploadSessionStatus;
(function (JoyUploadSessionStatus) {
    JoyUploadSessionStatus["started"] = "started";
    JoyUploadSessionStatus["inProgress"] = "inProgress";
    JoyUploadSessionStatus["waitingProcessing"] = "waitingProcessing";
    JoyUploadSessionStatus["finished"] = "finished";
    JoyUploadSessionStatus["incomplete"] = "incomplete";
    JoyUploadSessionStatus["error"] = "error";
})(JoyUploadSessionStatus || (JoyUploadSessionStatus = {}));
export default JoyUploadSessionStatus;
//# sourceMappingURL=JoyUploadSessionStatus.js.map